<template>
  <div id="index">
    <section class="topCar">
        <swiper :options="swiperOption" ref="mySwiper" v-if="managers.length !==0">
          <!-- slides -->
          <swiper-slide  v-for="(item, index) in managers" :key="index" style="overflow: hidden;width: 100%">
              <header>
                <div class="headerTitle">
                  <div class="hideTitleImg">
                    <img style="width:50px;height:50px;border-radius:25px;" :src=" item.managerHeadpicture? 'data:image/png;base64,' + item.managerHeadpicture :'/static/img/beidaziyuan/manager.jpg' " >
                  </div>
                  <p>{{item.managerName}}</p>
                </div>
              </header>

          </swiper-slide>

        </swiper>
        <header v-if="managers.length ===0">
          <div class="headerTitle">
            <div class="hideTitleImg">
              <img style="width:50px;height:50px;border-radius:25px;" src="../../../static/img/xinyuan/ManagePeople.png" >
            </div>
            <p>管家在线</p>
          </div>
        </header>

    </section>

    <section class="nav">
      <div class="nav_box">
        <div class="nav_Div" @click="repair">
          <img src="../../../static/img/xinyuan/greenbaoxiuSever.png">
          <p>报修服务</p>

        </div>
        <div class="nav_Div">
          <a :href.stop="'tel:' + 4007875588">
            <img src="../../../static/img/xinyuan/greencallIcon.png">
          </a>
          <p>一键呼叫</p>
        </div>
        <div class="nav_Div"  @click="complainListQing">
          <img src="../../../static/img/xinyuan/greentousu.png">
          <p>投诉受理</p>
        </div>
        <div class="nav_Div"  @click="complain">
          <img src="../../../static/img/xinyuan/greenadvise.png">
          <p>建议咨询</p>
        </div>
      </div>

    </section>

    <!-- 底部tab切换-->
    <footer>
      <div class="footerDiv" @click="homeIconClick(index)" v-for="(item,index) in notClick">
          <img :src='indexClick === index ? clickIcon[index].img : item.img' />
          <p :class="{active:(indexClick === index)}">{{item.title}}</p>
      </div>

    </footer>
    <!--弹窗-->
    <div v-if="sec4" class="sec4"></div>
    <section v-if="popUp" class="popUp">
      <img @click="close" src="../../../static/img/close.png">
      <p v-if="pa" class="pa">您还未绑定手机号，请立即去绑定</p>
      <p v-if="pb" class="pb">您还没有房产信息，请点击获取房产或点击更换手机号</p>
      <div v-if="pa" class="diva">
        <input @click="bangDing" type="text" value="绑定">
      </div>
      <div v-if="pb" class="divb clear">
        <input @click="fangchanxinxi" class="float-f" type="text" value="同步房产">
        <input @click="bangDing" class="float-r" type="text" value="更换手机号">
      </div>
    </section>
  </div>
</template>
<script>
  import homeIconImg from "../../../static/img/xinyuan/homeIcon.png"
  import recordingIconImg from "../../../static/img/xinyuan/recordingIcon.png"
  import myIconImg from "../../../static/img/xinyuan/myIcon.png"
  import homeIconImgGray from "../../../static/img/xinyuan/homeIconGray.png"
  import recordingIconImgGray from "../../../static/img/xinyuan/recordingIconGray.png"
  import myIconImgGray from "../../../static/img/xinyuan/myIconGray.png"
  import { swiper, swiperSlide } from 'vue-awesome-swiper'
  export default {
    components: {
      swiper,
      swiperSlide
    },
    data() {
      return {
        sec4: false,
        popUp: false,
        pa: false,
        pb: false,
        sliderinit: {
          currentPage: 0,
          thresholdDistance: 100,
          thresholdTime: 300,
          autoplay: 2000,
          loop: true,
          infinite: 1,
          slidesToScroll: 1,
          timingFunction: 'ease',
          duration: 500,
          typeNum: 0
        },
        clickIcon:[
          {
            img:homeIconImg,
            title:'首页'
          },
          {
            img:recordingIconImg,
            title:'服务记录'
          },
          {
            img:myIconImg,
            title:'个人信息'
          }
        ],
        notClick:[
          {
            img:homeIconImgGray,
            title:'首页'
          },
            {
              img:recordingIconImgGray,
              title:'服务记录'
            },
            {
              img:myIconImgGray,
              title:'个人信息'
            }
          ],
        colorTextType:false,
        indexClick:0,
        typeNum:0,
        managers: [
          // {managerName: '张二麻子', managerMobile: '15238216382', managerHeadpicture: ''},
          // {managerName: '张二麻子', managerMobile: '15238216382', managerHeadpicture: ''},
          // {managerName: '张二麻子', managerMobile: '15238216382', managerHeadpicture: ''},
        ],
        swiperOption:{
          notNextTick: true,
          loop:true,
          //设定初始化时slide的索引
          initialSlide:0,
          //自动播放
          autoplay:false,
          //滑动方向
          direction : 'horizontal',
          paginationClickable :true,
        }
      }
    },
    mounted(){
      const _this = this ;
      _this.getManagerInfo();
    },
    methods: {
      //获取管家信息
      getManagerInfo(){
        let _this = this;
        _this.postRequest('house/houseManagerList',{
          appId : sessionStorage.getItem('appId'),
          username : sessionStorage.getItem('userName')
        },function (data) {
          console.log(data)
          if(data){
            _this.managers = data
          }

        })
      },
      // 点击我的 跳转我的页面，获取关注的人的微信的信息包括 头像和昵称
      toMy() {//我的
        this.$router.push({name: 'my'})
      },
      close() {
        this.popUp = false
        this.sec4 = false
      },
      bangDing() {
        this.$router.push({name: 'checkTel'})
      },
      fangchanxinxi() {
        this.$router.push({name: 'houseInfo'})
      },
      initAddress() {
        const _this = this
        _this.postRequest('house/queryByUserId', {}, function (data) {
          if (data.length <= 0) {
            //弹窗
            _this.pb = true
            _this.popUp = true
            _this.sec4 = true
          } else {
            sessionStorage.setItem('el', data[0].name)
            sessionStorage.setItem('houseid', data[0].id)
            switch (_this.typeNum) {
              case 1:
                _this.$router.push({
                  name: 'repairQingMeng',
                  params: {
                    house: data
                  }
                })
                break;
              case 2:
                _this.$router.push({
                  name: 'adViseComlain',
                  params: {
                    house: data
                  }
                })
                break;
              // case 3:
              //   _this.$router.push({
              //     name: 'payXinYuan',
              //     params: {
              //       house: data
              //     }
              //   })
              //   break;
              case 4:
                _this.$router.push({
                  name: 'complainQingMeng',
                  params: {
                    house: data
                  }
                })
                break;
            }
          }
        })
      },
      acquireIphone() {
        const _this = this
        _this.postRequest('user/currentUserDetail ', {}, function (data) {
          if (data.phone) {
            _this.initAddress()
          } else {
            //弹窗
            _this.pa = true
            _this.popUp = true
            _this.sec4 = true
          }
        })
      },
      repair() {//报修
        this.typeNum = 1
        this.acquireIphone()
      },
      complain() {//建议
        this.typeNum = 2
        this.acquireIphone()
      },
      // toPay() {//缴费
      //   this.typeNum = 3
      //   this.acquireIphone()
      // },
      complainListQing(){//投诉
        this.typeNum = 4;
        this.acquireIphone();
      },

      // 底部的按钮
      homeIconClick(index){
        this.indexClick = index ;
        if(index === 0){
          this.$router.push('/homePageQingMeng')
        }else if(index === 1){
          this.$router.push('/myQingMeng')
        }else{
          this.$router.push('/personInfo')
        }
      }
    }
  }
</script>
<style scoped>
  .topCar{
    width: 100%;
    padding: 0 30px;
    box-sizing: border-box;
    padding-top: 20px;
  }
  .topCar header{
    width: 689px;
    height: 280px;
    background: url("../../../static/img/xinyuan/headerBg.png") no-repeat center;
    background-size: 100% 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
   .hideTitleImg{
     width:120px;
     height: 120px;
     border-radius: 50%;
     overflow: hidden;
     /*background: white;*/
     display: flex;
     align-items: center;
     justify-content: center;
     margin-bottom: 20px;
   }
  .hideTitleImg img{
    vertical-align: middle;
    width:120px;
    height: 120px;
    border-radius: 50%;
  }
  .headerTitle p{
    color:#FFFFFF;
    font-family: PingFangSC-Regular;
    font-size: 32px;
    width: 100%;
    text-align: center;
  }
  .nav {
    box-sizing: border-box;
    width: 100%;
    padding: 74px 105px 0 105px;
  }
  .nav_box{
     display: flex;
     flex-wrap:wrap;
  }
  .nav_Div{
    box-sizing:border-box ;
    width:250px;
    height:290px;
    background:rgba(255,255,255,1);
    box-shadow:0px 9px 17px 1px rgba(224,224,224,0.36);
    border-radius:6px;
    padding: 63px 0 0 70px;
    margin-right:20px ;
    margin-bottom: 30px;
  }
  .nav_Div:nth-of-type(2n){
    margin-right: 0;
  }
  .nav_box img{
    vertical-align: middle;
    width: 106px;
    height: 107px;
  }

  /*.nav_div{*/
    /*box-sizing: border-box;*/
    /*width: 470px;*/
    /*height: 260px;*/
    /*!*background: blue;*!*/
    /*display: flex;*/
    /*justify-content: center;*/
    /*align-items: center;*/
    /*color:#ffffff;*/
    /*margin-left: 20%;*/
    /*font-family:PingFangSC-Regular ;*/
    /*font-size: 32px;*/
  /*}*/
  /*.nav_div:first-of-type{*/
    /*background: url("../../../static/img/xinyuan/newBaoxiuBg.png") no-repeat center;*/
    /*background-size: 100% 100%;*/
    /*height: 311px;*/
    /*padding-top: 30px;*/
  /*}*/
  /*.nav_div:nth-of-type(2){*/
    /*background: url("../../../static/img/xinyuan/phoneCallBg.png") no-repeat center;*/
    /*background-size: 100% 100%;*/
  /*}*/
  /*.nav_div:last-of-type{*/
    /*background: url("../../../static/img/xinyuan/suggleBg.png") no-repeat center;*/
    /*background-size: 100% 100%;*/
  /*}*/
  /*.nav_div img{*/
    /*vertical-align: middle;*/
    /*width:97px;*/
    /*height: 97px;*/
  /*}*/
  /*.nav_div img:nth-of-type(2){*/
    /*width:91px;*/
    /*height: 91px;*/
  /*}*/
  /*.today{*/
    /*margin: 29px;*/
  /*}*/

  .today .p1 {
    font-size: 48px;
    color: rgba(51, 51, 51, 1);
    font-weight: 900;
    margin-bottom: 20px;
  }

  .today .p2 {
    font-size: 28px;
    margin-left: 10px;
    color: rgba(153, 153, 153, 1);
  }

  .today .p2 img {
    width: 30px;
    height: 36px;
    vertical-align: middle;
    margin-right: 23px;
  }

  .my-img img {
    width: 80px;
    height: 80px;
    margin: 50px 32px 0 0;
  }

  /*遮罩样式*/
  .sec4 {
    width: 100%;
    height: 1334px;
    background: #000000;
    opacity: .4;
    z-index: 10;
    position: fixed;
    top: 0;
  }

  .clear {
    overflow: hidden;
    zoom: 1;
  }

  .float-f {
    float: left;
  }

  .float-r {
    float: right;
  }

  .popUp {
    z-index: 20;
    background: #fff;
    border-radius: 10px;
    width: 88%;
    height: 302px;
    position: fixed;
    top: 480px;
    left: 50%;
    transform: translateX(-50%);
  }

  .popUp img {
    width: 28px;
    height: 28px;
    margin-left: 620px;
    margin-top: 16px;
  }

  /*绑定弹框*/
  .popUp .pa {
    line-height: 70px;
    font-size: 28px;
    text-align: center;
  }

  .popUp .diva input {
    width: 38%;
    height: 68px;
    font-size: 30px;
    text-align: center;
    background: rgb(27, 130, 209);
    border-radius: 90px;
    color: #fff;
    margin: 60px 0 0 200px;
  }

  /*获取房产 和 更换手机号 弹框*/
  .popUp .pb {
    width: 75%;
    padding: 0 40px;
    text-align: center;
    margin: 30px 0;
    margin-left: 50%;
    transform: translateX(-50%);
    font-size: 28px;
  }

  .popUp .divb {
    margin-top: -10px;
    margin: 0 50px;
  }

  .popUp .divb input {
    width: 38%;
    height: 68px;
    font-size: 30px;
    text-align: center;
    background: rgb(27, 130, 209);
    border-radius: 90px;
    color: #fff;
    margin: 10px 0;
  }

  /* 固定二倍图尺寸 */
  .more2 {
    width: 12px;
    height: 21px;
  }

  .fl {
    float: left;
  }

  #index {
    width: 100%;
    background-color: #fff;
    text-align: left;
  }
  /*------footer-----*/
footer{
  position: fixed;
  padding-top: 20px;
  bottom: 20px;
  width: 100%;
  display: flex;
  justify-content: space-around;
  background:rgba(255,255,255,1);
  box-shadow:0px -8px 17px 1px rgba(229,229,231,0.32);
}
  .footerDiv{
    font-size: 24px;
    color:#D5D5D5;
    text-align: center;
  }
  /*.footerDiv:first-of-type{*/
    /*color:#515151;*/
  /*}*/
  .active{
    color:#515151;
  }
  .footerDiv img{
    vertical-align: middle;
    width: 48px;
    height: 48px;
    margin-bottom: 10px;
  }
  .footerDiv:nth-of-type(2) img{
    width: 41px;
    height: 50px;
  }
  .footerDiv:last-of-type img{
    width: 44px;
    height: 44px;
  }
</style>



// WEBPACK FOOTER //
// src/components/xinyuan/homePage-qingMeng.vue